import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { reducer as formReducer } from 'redux-form'
import { reducer as notifications } from 'react-notification-system-redux'

import appReducer, { moduleName as appModule } from '../ducks/app'
import authReducer, { moduleName as authModule } from '../ducks/auth'
import emailReducer, { moduleName as emailModule } from '../ducks/email'
import propertiesReducer, {
  moduleName as propertiesModule
} from '../ducks/properties'

import profileReducer, { moduleName as profileModule } from '../ducks/profile'

import chartReducer, { moduleName as chartModule } from '../ducks/chart'
import productsReducer, {
  moduleName as productsModule
} from '../ducks/products'
import statesReducer, { moduleName as statesModule } from '../ducks/states'
import interactionsReducer, {
  moduleName as interactionsModule
} from '../ducks/interactions'
import interactionReducer, {
  moduleName as interactionModule
} from '../ducks/interaction'
import uiReducer, { moduleName as uiModule } from '../ducks/ui'
import createInteractionReducer, {
  moduleName as createInteractionModule
} from '../ducks/createInteraction'
import contractsReducer, {
  moduleName as contractsModule
} from '../ducks/contracts'
import transactionsReducer, {
  moduleName as transactionsModule
} from '../ducks/transactions'
import newsReducer, { moduleName as newsModule } from '../ducks/news'
import interactionsPreviewReducer, {
  moduleName as interactionsPreviewModule
} from '../ducks/interactionsPreview'

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    form: formReducer,
    [appModule]: appReducer,
    [authModule]: authReducer,
    [emailModule]: emailReducer,
    [propertiesModule]: propertiesReducer,
    [profileModule]: profileReducer,
    [chartModule]: chartReducer,
    [productsModule]: productsReducer,
    [statesModule]: statesReducer,
    [interactionModule]: interactionReducer,
    [interactionsModule]: interactionsReducer,
    [uiModule]: uiReducer,
    [createInteractionModule]: createInteractionReducer,
    [contractsModule]: contractsReducer,
    [transactionsModule]: transactionsReducer,
    [newsModule]: newsReducer,
    [interactionsPreviewModule]: interactionsPreviewReducer,
    notifications
  })
